import { LabelValue } from '../interfaces/interfaces';

export const STATUSES: LabelValue[] = [
    { label: 'Nem aktivált (Új)', value: 'NOT_ACTIVATED' },
    { label: 'Aktivált', value: 'ACTIVATED' },
    { label: 'Deaktivált', value: 'DEACTIVATED' }
];

export const STOCK_RIGHTS: LabelValue[] = [
    { label: 'Webshop alapbeállításai szerinti', value: 'DEFAULT' },
    { label: 'Nem látja a  készletet', value: 'NO' },
    { label: 'Annyit lát hogy: Van vagy Nincs', value: 'BOOLEAN' },
    { label: 'Pontos készletet láthat', value: 'EXACT' }
];

export const VAT_TYPES: LabelValue[] = [
    { label: 'Belföldi', value: 'DOMESTIC' },
    { label: 'Ismeretlen', value: 'UNKNOWN' },
    { label: 'Közösségen belüli adómentes', value: 'EU' },
    { label: 'Közösségen belüli áfás', value: 'EU_WITH_VAT' },
    { label: 'Közösségen kívüli', value: 'NON_EU' }
];

export const LEGAL_STATUSES: LabelValue[] = [
    { label: 'Magánszemély', value: 'PRIVATE' },
    { label: 'Adószámos magánszemély', value: 'PRIVATE_WITH_TAXNUMBER' },
    { label: 'Cég', value: 'COMPANY' }
];
